<script>
import moment from 'moment'

export default {
  props: {
    Specialty: { type: Object },
  },
  data() {
    return {
    }
  },
  computed: {
    criado() {
      return this.Specialty.created_at ? moment(this.Specialty.created_at).format('DD/MM/YYYY HH:mm') : 'Não informado';
    },
    atualizado() {
      return this.Specialty.updated_at ? moment(this.Specialty.updated_at).format('DD/MM/YYYY HH:mm') : 'Não informado';
    },
  },
}
</script>

<template>
<div class="Specialty">
  <p>ID: {{ Specialty.id }}</p>
  <p>Nome: {{ Specialty.name }}</p>
  <p>Criado: <b-badge data-name="created_at" class="field-created_at" variant="secondary">{{ criado }}</b-badge></p>
  <p>Última alteração: <b-badge data-name="updated_at" class="field-updated_at" variant="secondary">{{ atualizado }}</b-badge></p>
</div>
</template>